<template
  ><v-row dense>
    <v-col
      cols="12"
      sm="12"
      md="12"
      v-for="(control, index) in controlChanges"
      :key="index"
    >
      <v-card elevation="0"
        ><v-banner color="blue-grey lighten-5" class="black--text" single-line>
          <div class="text-center">
            <span class="text-h6">VERSIÓN: {{ control.version }} </span>
            <span>({{ control.date }})</span>
          </div>
        </v-banner>
        <v-timeline
          align-top
          dense
          v-for="(feature, index) in control.feature"
          :key="index"
        >
          <v-timeline-item color="#59805c" small>
            <h2 class="pb-2">
              {{ feature.name }}
            </h2>
            <div
              v-for="(value, index) in feature.changes"
              :key="index"
              class="body-2 pl-5"
            >
              {{ index + 1 }}.- {{ value.value }}
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-card>
      <br />
    </v-col>
  </v-row>
</template>

<script>
import controlChanges from "@/app/json/changeControl.json";
export default {
  data() {
    return {
      controlChanges: controlChanges,
    };
  },
};
</script>

<style></style>
